import { Injector, NgModule } from '@angular/core';
import { SendEventAllianceIframe } from './send-event-alliance-iframe';

export let AppInjector: Injector;
@NgModule({
  providers: [SendEventAllianceIframe],
})
export class UtilityModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
